import React, { useState } from "react";
import "./index.css";
import { RestaurantSummary } from "./RestaurantSummary";
import { InventoryTabs } from "./InventoryTabs";
import { useSelector } from "react-redux";
import LoadingMessage from "../../../components/LoadingMessage";
import { useFirebaseProductOverview } from "../../../hooks/useFirebaseProductOverview ";
import { useFirebaseProductSummaries } from "../../../hooks/useFirebaseProductSummaries";

export const RealtimeInventoryDashboard: React.FC = () => {
  const selectedRestaurantId = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails.id
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchQuery, setSearchQuery] = useState("");

  // Use Firebase hooks for both overview and summaries
  const {
    data: productOverviewData,
    loading: isOverviewLoading,
    error: overviewError,
  } = useFirebaseProductOverview(selectedRestaurantId);

  const {
    data: productSummariesData,
    loading: isSummariesLoading,
    error: summariesError,
  } = useFirebaseProductSummaries(selectedRestaurantId);

  // Filter overview products for search
  const filteredOverviewProducts = React.useMemo(() => {
    if (!productOverviewData) return [];

    return productOverviewData.filter(
      (item: any) =>
        item.displayName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (item.ProductId || item.productId || "").toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [productOverviewData, searchQuery]);

  const isLoading = isOverviewLoading || isSummariesLoading;
  const error = overviewError || summariesError;

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <LoadingMessage />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        Error loading inventory data: {error.message}
      </div>
    );
  }

  return (
    <div className="realtime-inventory-dashboard-container">
      <RestaurantSummary productOverviewData={filteredOverviewProducts} />
      <InventoryTabs 
        overviewProducts={filteredOverviewProducts} 
        productSummaries={productSummariesData || []}
      />
    </div>
  );
};